/**
 * Walking mascot assets (designed for small bottom-bar use — not hero photography).
 *
 * SWAP when final brand file arrives:
 *   - Replace public/images/duck-mascot.svg, or
 *   - Set REACT_APP_DUCK_IMAGE_URL to e.g. /images/duck.png
 */

/** Vector mascot — soft watercolor-style, transparent, scales cleanly at ~50px */
export const DUCK_MASCOT_SVG = `${process.env.PUBLIC_URL}/images/duck-mascot.svg`;

/** Optional PNG fallback (isolated illustration from brand kit) */
export const DUCK_MASCOT_PNG_FALLBACK =
    "https://static.prod-images.emergentagent.com/jobs/3af35290-5c18-4b44-9040-8af3e70333b3/images/5370a1fb2490f2ea5ad0f386ed248d34890c7a755b71c3d5b6edbbac56c7ae59.png";
